import { API_HOST } from "api/http";

export const proxyUrl = (url) => {
    // No token means signed out: send none rather than the string "null".
    const token = localStorage.getItem('token');
    const auth = token ? `token=${encodeURIComponent(token)}&` : '';
    return `${API_HOST}/api/proxy?${auth}url=${encodeURIComponent(url)}`;
}
